module.exports = __webpack_public_path__ + "img/part3-icon2-over.7a81fa94.png";